// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"7b298b84","419":"2ee242cb","466":"f1793d8a","510":"ec77484a","554":"dbc4605a","711":"c575ed18","726":"49fe0022","738":"aa541d8f","753":"2a1c7776","774":"77a73fb9","787":"c8d4c496","856":"eaad2095","858":"c9d509d2","895":"35b7c386"}[chunkId] + ".chunk.js";
};